/* eslint-disable max-classes-per-file */
import APIService from '@/services/API';
import Shared from '@/services/shared';

const getLevelsData = async () => {
  try {
    const request = new Shared.GetLevelsServiceRequest();
    const service = new Shared.GetLevelsService(request);
    return await service.do();
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getTechnologiesData = async () => {
  try {
    const request = new Shared.GetTechnologiesServiceRequest();
    const service = new Shared.GetTechnologiesService(request);
    return await service.do();
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getDisciplinesData = async () => {
  try {
    const request = new Shared.GetDisciplinesServiceRequest();
    const service = new Shared.GetDisciplinesService(request);
    return await service.do();
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getCitiesData = async () => {
  try {
    const request = new Shared.GetCitiesServiceRequest();
    const service = new Shared.GetCitiesService(request);
    return await service.do();
  } catch (e) {
    console.error(e);
    return [];
  }
};

const getInterviewTypes = async (id) => {
  try {
    const request = new Shared.GetInterviewTypesServiceRequest({ disciplineId: id });
    const service = new Shared.GetInterviewTypesService(request);
    return await service.do();
  } catch (e) {
    console.error(e);
    return [];
  }
};

/* eslint-disable camelcase */
const PostMenteeServiceRequest = function constructor({
  name,
  last_name,
  bamboo_employee_id,
  technologies_ids,
  discipline_id,
  level_id,
  city_id,
  join_date,
  manager,
  other_technologies,
  has_past_experience,
  shadowing_interview_types,
  leading_interview_types,
  graduated_interview_types,
}) {
  this.name = name;
  this.last_name = last_name;
  this.bamboo_employee_id = bamboo_employee_id;
  this.technologies_ids = technologies_ids;
  this.discipline_id = discipline_id;
  this.level_id = level_id;
  this.city_id = city_id;
  this.join_date = new Date(join_date).toISOString();
  this.manager = manager;
  this.other_technologies = other_technologies;
  this.has_past_experience = has_past_experience;
  this.shadowing_interview_types = shadowing_interview_types;
  this.leading_interview_types = leading_interview_types;
  this.graduated_interview_types = graduated_interview_types;
};

const PostMenteeServiceResponse = function constructor({ mentee_id, scopes_token }) {
  this.mentee_id = mentee_id;
  this.scopes_token = scopes_token;
};
/* eslint-enable camelcase */

class PostMenteeService extends APIService {
  constructor(postMenteeServiceRequest) {
    super();
    this.serviceURL = '/mentees';
    this.request = postMenteeServiceRequest;
  }

  async do() {
    this.setAuthorizationHeaders();
    try {
      const response = await this.createHttpRequest().post(this.serviceURL, this.request);
      return new PostMenteeServiceResponse(response.data);
    } catch (error) {
      throw error.response;
    }
  }
}

const postMentee = async (formData) => {
  try {
    const groupInterviewTypes = Object.groupBy(formData.interviewTypes, ({ value }) => value);

    const request = new PostMenteeServiceRequest({
      name: formData.name,
      last_name: formData.last_name,
      bamboo_employee_id: formData.bamboo_employee_id,
      technologies_ids: formData.technologies_ids,
      discipline_id: formData.discipline_id,
      level_id: formData.level_id,
      city_id: formData.city_id,
      join_date: formData.join_date,
      manager: formData.manager,
      other_technologies: formData.other_technologies,
      has_past_experience: formData.has_past_experience,
      shadowing_interview_types: groupInterviewTypes.shadow ? groupInterviewTypes.shadow.map((obj) => obj.id) : [],
      leading_interview_types: groupInterviewTypes.lead ? groupInterviewTypes.lead.map((obj) => obj.id) : [],
      graduated_interview_types: groupInterviewTypes.graduated
        ? groupInterviewTypes.graduated.map((obj) => obj.id)
        : [],
    });
    const service = new PostMenteeService(request);
    return await service.do();
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export default {
  getLevelsData,
  getTechnologiesData,
  getCitiesData,
  postMentee,
  getDisciplinesData,
  getInterviewTypes,
};
